import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import React from 'react';


// Get the root container
const container = document.getElementById('root');

if (!container) {
  throw new Error("Root container is missing in the DOM.");
}

// Create the root and render the application
const root = createRoot(container);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
